import { createSlice } from '@reduxjs/toolkit';

/** Loading 狀態型別 */
export type LoadingState = boolean;

/**
 * Loading Slice
 * 控制全域載入狀態
 */
export const loadingSlice = createSlice({
  name: 'loading',
  initialState: false as LoadingState,
  reducers: {
    open: () => true,
    close: () => false
  }
});

export const { actions, reducer } = loadingSlice;
export const { open, close } = actions;
export default reducer;
